/**
 * dialogueBubble.js — v242.72.0 (DIALOGUE-BUBBLE-1)
 *
 * ONE definition of the surface Orella speaks from, for the whole app.
 *
 * The bubble was #E9F8FF on a #A7D9FC border at 15px. That border is the SAME
 * ice blue the app uses for chips, cards, selected states and the chat card's
 * own frame, so a dialogue bubble sitting inside an ice-blue card read as a
 * panel inside a panel — and the loudest colour on screen was chrome rather
 * than the 4D hues, which are the only colours in this product that carry
 * meaning.
 *
 * It is quieter now: #F0F9FF on a #DCEEFB hairline, 13.5px/1.55, 14px radius
 * with a 5px tuck at the speaker's corner.
 *
 * There were ELEVEN copies of the old style across seven files — five inside
 * OrellaChatAgent alone, the rest in OrellaChatHeader, OrellaPageHeader,
 * ProfileSectionIntro, ProfileSubpageLayout and FocusAreas (twice) — three of
 * them written as inline `style` objects rather than classes, which is why a
 * grep for the class name found only some of them. That is the reason this file
 * exists: the next restyle changes one constant, not eleven strings that no
 * single search will reliably enumerate.
 */

/** Assistant/Orella bubble: fill, hairline, text colour, radius with the speaker tuck. */
export const DIALOGUE_BUBBLE =
  'bg-[#F0F9FF] border border-[#DCEEFB] text-[#15354F] rounded-[14px] rounded-tl-[5px]'

/** Body copy inside a dialogue bubble. */
// v242.77.0 (TF-28) "Increase size of orella dialogue text". 13.5px came from
// the v5 mockup, which was drawn at desktop width; on a 6.1" phone it reads
// small. Back to 15px — the size the app shipped before DIALOGUE-BUBBLE-1 — with
// the mockup's looser 1.55 leading kept, which is what made 13.5 look right in
// the mock in the first place.
export const DIALOGUE_TEXT = 'text-[15px] leading-[1.55] font-medium whitespace-pre-wrap'

/** Padding inside a dialogue bubble. */
export const DIALOGUE_PAD = 'px-3 py-2.5'

